import IndustryTypeService from 'Services/IndustryType';

const getIndustryTypes = async (): Promise<any> => {
  try {
    const res = await IndustryTypeService();
    if (res) {
      
      return res;
    }
  } catch (error) {
    console.error('Error fetching continents:', error);
  }
};

export default getIndustryTypes;
